import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

import { useFirebase } from '@meddbriefer/mdb-firebase';
import { getCollection, deleteDocument } from "@meddbriefer/scenario-data"

const COLLECTION_ID = 'class-codes';

export default function ClassCodesList() {
    const {db} = useFirebase()
    const [ codes, setCodes ] = useState(null);

    useEffect(
        () => {
            getCollection(db, COLLECTION_ID)
                .then((result) => { setCodes(result); })
                .catch((err) => { console.log(err); })
        },
        [db]
    )


    const handleDelete = async (item)  => {
        let id = item.id;
        if (window.confirm('Are you sure you want to permanently this item? This cannot be undone!')) {
            await deleteDocument(db, COLLECTION_ID, id);
            let dup = codes.slice();
            dup.splice(dup.indexOf(item), 1);
            setCodes(dup);
        } else
            console.log(`Delete of ${item.title} cancelled.`);
    }

    if (!codes) {
        return (<div>Loading...</div>)
    }
    return (
        <div className="db-list">
            <h1>Class Codes</h1>
            <Link
                to={`/class-code/`}
                className="new-bttn db-list-item"
            >
                <h2>New Class Code</h2>
            </Link>

            {codes.map( item =>
                <div
                    key={item.id}
                    className="db-list-item"
                >
                    <h2>{item.name}</h2>
                    <div className="list-button-wrapper">
                        <Link
                            to={`/class-code/${item.id}`}
                            className="action-bttn"
                        >
                            Edit
                        </Link>
                        <button
                            type="button"
                            className="action-bttn delete-bttn"
                            onClick={() => handleDelete(item)}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            )}

        </div>
    )

}
